import { AccessMode } from "../../../models/constants/accessMode";
import { localStorageService } from "../../../services";
import errorModal from "../../../services/errorModal.service";
import { bonusApi } from "../api/bonus.api";
import {
  CommonBonusDetails,
  BonusTurnOverDetails,
  IncludeExcludeProvidersGamesDetails,
  BonusDetailPerDayResponseDetails,
} from "../models/responses/index";


export async function retrieveAllCancelledBonusDetails(
  pageNumber: number,
  pageSize: number,
): Promise<CommonBonusDetails[] | null> {
  const cancelledBonusresult = await bonusApi.retriveAllCancelledBonusListApi({
    pageNo: pageNumber,
    pageSize: pageSize,
  });
  if (cancelledBonusresult.isSuccess) {
    const allCancelledBonusDetails = cancelledBonusresult.data?.details ?? [];
    allCancelledBonusDetails.forEach((promo) => {
      promo.bonusdescription = htmlDecode(promo.bonusdescription!);
      promo.bonushindidescription = htmlDecode(promo.bonushindidescription!);
    });
    return allCancelledBonusDetails;
  }
  else {
    errorModal.showErrorModal(cancelledBonusresult.statusCode, cancelledBonusresult.message);
    return null;
  }
}

export async function retrieveAllExpiredBonusDetails(
  pageNumber: number,
  pageSize: number,
) {
  const expiredBonusResult = await bonusApi.retriveAllExpiredBonusListApi({
    pageNo: pageNumber,
    pageSize: pageSize,
  });

  if (expiredBonusResult.isSuccess) {
    const allExpiredBonus = expiredBonusResult.data?.details ?? [];
    allExpiredBonus.forEach((promo) => {
      promo.bonusdescription = htmlDecode(promo.bonusdescription!);
      promo.bonushindidescription = htmlDecode(promo.bonushindidescription!);
    });
    return allExpiredBonus;
  }
  else {
    errorModal.showErrorModal(expiredBonusResult.statusCode, expiredBonusResult.message);
    return null;
  }
}

export async function retrieveAllConsumedBonusDetails(
  pageNumber: number,
  pageSize: number,
) {
  const consumedBonusResult = await bonusApi.retriveAllConsumedBonusList({
    pageNo: pageNumber,
    pageSize: pageSize,
  });

  if (consumedBonusResult.isSuccess) {
    const allConsumedBonus = consumedBonusResult.data?.details ?? [];
    allConsumedBonus.forEach((promo) => {
      promo.bonusdescription = htmlDecode(promo.bonusdescription!);
      promo.bonushindidescription = htmlDecode(promo.bonushindidescription!);
    });
    return allConsumedBonus;
  }
  else {
    errorModal.showErrorModal(consumedBonusResult.statusCode, consumedBonusResult.message);
    return null;
  }
}

export async function checkAndConsumeCashdrop(
  bonusId: string,
  bonusWalletTransactionId: string,
): Promise<boolean> {

  const result = await bonusApi.activateCashdrop({
    bonusId,
    bonusWalletTransactionId,
  });
  if (result.isSuccess) {
    return true;
  }
  else {
    errorModal.showErrorModal(result.statusCode, result.message);
    return false;
  }
}

export async function retrieveActiveBonusDetails(accessModeSource: string): Promise<
  CommonBonusDetails[] | null
> {

  const result = await bonusApi.activeBonusRetrieveListApi({
    Id: null,
    AccessMode: accessModeSource.toLowerCase() === AccessMode.App.toLowerCase() ? 2 : 1,
  });
  if (result.isSuccess) {
    // return result.data?.details ?? [];
    const details = result.data?.details ?? [];
    return details.map((b) => ({
      bonusid: b.bonusid,
      bonusname: b.bonusname,
      bonusexpiredate: b.bonusexpiredate,
      bonusenddate: b.bonusenddate,
      Created: null,
      modified: b.modified,
      bonustype: b.bonustypename,
      NameToCheck: b.nametocheck,
      bonuswallettransactionid: b.bonuswallettransactionid,
      bonusamount: b.bonusamount,
      wageringrequired: b.wageringrequired,
      wageringremaining: b.wageringremaining,
      minimumodds: b.minimumodds,
      depositbonusstagstring: b.depositbonusstagstring,
      verticalbonusname: b.verticalbonusname,
      isBonusEnable: b.isbonusenable,
      isDirectBonus: b.isdirectbonus,
      promoPercentage: b.promopercentage,
      bonusdescription: htmlDecode(b.bonusdescription),
      bonushindidescription: htmlDecode(b.bonushindidescription),
      depositaccesslimit: b.depositaccesslimit,
      bonuscap: b.bonuscap,
      depositType: b.deposittype,
      bonusValidity: b.bonusvalidity,
      claimingdate: b.claimingdate ?? null,
      maxcashbackpercycle: b.maxcashbackpercycle ?? null,
      maxcashbackperbonuscampaign: b.maxcashbackperbonuscampaign ?? null,
      isbonuscreditingtimevisible: b.isbonuscreditingtimevisible ?? null,
      repeatevery: b.repeatevery ?? null,
      repeatoncsv: b.repeatoncsv ?? null,
      settlementrepeatoncsv: b.settlementrepeatoncsv,
      settlementstarttime: b.settlementstarttime ?? null,
      fixrewardhours: b.fixrewardhours ?? null,
      starttime: b.starttime ?? null,
      endtime: b.endtime ?? null,
      includegamenamescsv: b.includegamenamescsv,
      excludegamenamescsv: b.excludegamenamescsv,
      includegameprovidernamescsv: b.includegameprovidernamescsv,
      excludegameprovidernamescsv: b.excludegameprovidernamescsv,
      possiblesettlementdate: b.possiblesettlementdate ?? null,
      bonusrewardstartdatetime: b.bonusrewardstartdatetime ?? null,
      bonusrewardenddatetime: b.bonusrewardenddatetime ?? null,
      exchangegameproviderids: b.exchangegameproviderids ?? null,
      isindividualminimumoddsenabled: b.isindividualminimumoddsenabled,
      exchangeminimumoddsjson: b.exchangeminimumoddsjson,
      exchangeMinimumOdds: [],
      sportssubverticalname: b.sportssubvertical ?? null,
      // FreeSpin defaults
      status: b.bonusstatus,
      gamename: "",
      gameTypeName: "",
      freespincount: 0,
      isConsecutive: false,
      noOfDays: null,
      remainingActiveFreeSpinCount: 0,
      consumedfreespincount: 0,
      expiredfreespincount: 0,
      totalfreespinbonusamount: 0,
      nextFsRoundDate: null,
      gameCode: "",
      gameId: "",
    }));
  }
  else {
    errorModal.showErrorModal(result.statusCode, result.message);
    return null;
  }
}

export async function retrieveFreeSpinBonusDetails(accessModeSource: string): Promise<
  CommonBonusDetails[] | null
> {

  const result = await bonusApi.freespinBonusRetrieveListApi({
    BonusStatus: "Active",
    AccessMode: accessModeSource.toLowerCase() === AccessMode.App.toLowerCase() ? 2 : 1,
    BonusId: null,
  });
  if (result.isSuccess) {
    const details = result.data?.details ?? [];
    return details.map((b) => ({
      bonusid: b.bonusid,
      bonusname: b.bonusname,
      bonusexpiredate: b.bonusexpiredate,
      bonusenddate: null,
      Created: b.created,
      modified: b.modified,
      NameToCheck: b.nametocheck,
      bonustype: b.bonustype,
      status: b.status,
      gamename: b.gamename,
      gameTypeName: b.gametypename,
      freespincount: b.freespincount,
      isConsecutive: b.isconsecutive,
      noOfDays: b.noofdays ?? null,
      remainingActiveFreeSpinCount: b.remainingactivefreespincount,
      consumedfreespincount: b.consumedfreespincount,
      expiredfreespincount: b.expiredfreespincount,
      totalfreespinbonusamount: b.totalfreespinbonusamount,
      nextFsRoundDate: b.nextfsrounddate ?? null,
      gameCode: b.gamecode,
      gameId: b.gameid,
      bonuswallettransactionid: b.bonuswallettransactionid,
      bonusamount: 0,
      wageringrequired: 0,
      wageringremaining: 0,
      minimumodds: 0,
      depositbonusstagstring: null,
      verticalbonusname: null,
      isBonusEnable: false,
      isDirectBonus: false,
      promoPercentage: 0,
      bonusdescription: null,
      bonushindidescription: null,
      depositaccesslimit: null,
      bonuscap: null,
      depositType: null,
      bonusValidity: null,
      claimingdate: null,
      maxcashbackpercycle: null,
      maxcashbackperbonuscampaign: null,
      isbonuscreditingtimevisible: null,
      repeatevery: null,
      repeatoncsv: null,
      settlementrepeatoncsv: null,
      settlementstarttime: null,
      fixrewardhours: null,
      starttime: null,
      endtime: null,
      includegamenamescsv: null,
      excludegamenamescsv: null,
      includegameprovidernamescsv: null,
      excludegameprovidernamescsv: null,
      possiblesettlementdate: null,
      bonusrewardstartdatetime: null,
      bonusrewardenddatetime: null,
      exchangegameproviderids: null,
      isindividualminimumoddsenabled: false,
      exchangeminimumoddsjson: null,
      exchangeMinimumOdds: [],
      sportssubverticalname: null,
    }));
  }
  else {
    errorModal.showErrorModal(result.statusCode, result.message);
    return null;
  }
}

export async function checkAndActivateCashdropBonus(
  bonusId: string | null,
  accessModeSource: string,
): Promise<boolean> {
  const result = await bonusApi.checkAndActivateCashdropBonus({
    Id: bonusId || null,
    AccessMode:
      accessModeSource.toLowerCase() === AccessMode.App.toLowerCase() ? "2" : "1",
  });
  if (result.isSuccess) {
    return true;
  }
  else {
    errorModal.showErrorModal(result.statusCode, result.message);
    return false;
  }
}

export async function checkAndActivateFreeSpinBonus(
  bonusId: string | null,
  accessModeSource: string,
): Promise<boolean> {
  const result = await bonusApi.checkAndActivateFreeSpinBonus({
    Id: bonusId || null,
    AccessMode:
      accessModeSource.toLowerCase() === AccessMode.App.toLowerCase() ? "2" : "1",
  });
  if (result.isSuccess) {
    return true;
  }
  else {
    errorModal.showErrorModal(result.statusCode, result.message);
    return false;
  }
}

export async function checkAndActiveCashbackWinningBoost(
  BonusWalletTransactionId: string
): Promise<boolean> {
  const result = await bonusApi.checkAndActivateCashbackWinningBoost(
    BonusWalletTransactionId
  );

  if (result.isSuccess) {
    return true;
  }
  else {
    errorModal.showErrorModal(result.statusCode, result.message);
    return false;
  }
}

export async function updateUsersFreeSpinCancellation() {
  var result = await bonusApi.updateUsersFreeSpinCancellation();

  if (!result.isSuccess) {
    errorModal.showErrorModal(result.statusCode, result.message);
  }
}

export async function retrieveCasinoBonusTurnOverDetail(
  bonusId: string,
  bonusWalletTransactionId: string,
): Promise<BonusTurnOverDetails[] | null> {
  const result = await bonusApi.bonusTurnOverRetrieveListApi({
    bonusId,
    bonusWalletTransactionId,
  });
  if (result.isSuccess) {
    return result.data?.details ?? [];
  }
  else {
    errorModal.showErrorModal(result.statusCode, result.message);
    return null;
  }
}

export async function retrieveExchangeBonusTurnOverDetails(
  bonusId: string,
  bonusWalletTransactionId: string,
): Promise<BonusTurnOverDetails[] | null> {
  const result = await bonusApi.exchangeBonusTurnOverRetrieveListApi({
    bonusId,
    bonusWalletTransactionId,
  });
  if (result.isSuccess) {
    return result.data?.details ?? [];
  }
  else {
    errorModal.showErrorModal(result.statusCode, result.message);
    return null;
  }
}

export async function retrieveSportsBonusTurnOverDetails(
  bonusId: string,
  bonusWalletTransactionId: string,
): Promise<BonusTurnOverDetails[] | null> {
  const result = await bonusApi.sportsBonusTurnOverRetrieveListApi({
    bonusId,
    bonusWalletTransactionId,
  });
  if (result.isSuccess) {
    return result.data?.details ?? [];
  }
  else {
    errorModal.showErrorModal(result.statusCode, result.message);
    return null;
  }
}
export async function onIncludeExcludeProviderGame(
  id: string | null,
): Promise<IncludeExcludeProvidersGamesDetails[]> {
  const result = await bonusApi.onIncludeExcludeProviderGame(id);

  if (result.isSuccess) {
    return result.data?.details ?? [];
  }
  else {
    errorModal.showErrorModal(result.statusCode, result.message);
    return [];
  }
}
export async function activateCashbackAndWinningBoost(
  accessModeSource: string,
) {
  var result = await bonusApi.activateCashbackAndWinningBoost(accessModeSource.toLowerCase() === AccessMode.App.toLowerCase() ? 2 : 1);

  if (!result.isSuccess) {
    errorModal.showErrorModal(result.statusCode, result.message);
  }
}
export async function retrieveDateWiseBonusDetail(
  bonusId: string,
  pageNumber: number = 1
): Promise<BonusDetailPerDayResponseDetails | null> {
  const userId = localStorageService.getItem<string>("userId");
  if (!userId) return null;

  const result = await bonusApi.retrieveUsersBonusByDate({
    PageNo: pageNumber - 1,
    PageSize: 10,
    UserId: userId,
    BonusId: bonusId,
  });

  if (result?.isSuccess && result.data) {
    return result.data;
  }
  return null;
}
function htmlDecode(input: string) {
  const txt = document.createElement("textarea");
  txt.innerHTML = input;
  return txt.value;
}

export async function cancelDepositBonus(
  bonusId: string,
  bonusWalletTransactionId: string,
): Promise<any> {
  const result = await bonusApi.cancelDepositBonus({
    bonusId: bonusId,
    bonusWalletTransactionId: bonusWalletTransactionId,
  });

  if (result.isSuccess) {
    return result;
  }
  else {
    errorModal.showErrorModal(result.statusCode, result.message);
    return null;
  }
}
